import React from 'react';
import PropTypes from 'prop-types';
import './NgApiIntegration.scss';

const NgApiIntegration = () => {
  return (
    <div className="main-right-side-section">
      <div className="ngapi-main-section">
        <section>
          <div className="ngapi-section-1">
            <div className="ngapi-section-1-inner">
              <p>API integration</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

NgApiIntegration.propTypes = {};

NgApiIntegration.defaultProps = {};

export default NgApiIntegration;
